import { Module } from 'vuex';
import RootState from '../../state';
import { searchPoolsV2UsingPOST } from '@services/distribution/pool-controller';
import { searchRulesUsingPOST } from '@services/distribution/rule-controller';
import { detailUsingPOST } from '@services/distribution/distributor-controller';
import {
    IPoolVo,
    IRuleListVo,
    IRuleVo,
    ISearchPoolParam,
    ISearchRuleParam,
    IPoolListVO
} from '../../../../services/distribution/models';
import LS from '@utils/storageExtend';
const { localStorage } = LS;

interface IGoods extends IPoolVo {
    selected?: boolean;
}

interface IPreCart extends IRuleVo {
    selected?: boolean;
}

interface IDistributor {
    distributorId?: number;
    distributorPid?: string;
}

interface ILeagueState {
    goodsData: IGoods[];
    selectedGoods: IGoods[];
    totalCount: number;
    exclusiveNotifications: number; // 专属分销更新小红点提示

    // 我的选品库数据
    preCartCount: number;
    selectedPreCart: IPreCart[];
    preCartData: IPreCart[];

    // 分销者信息
    distributor: IDistributor;
}

const initialState = {
    goodsData: [],
    selectedGoods: [],
    totalCount: 0,
    exclusiveNotifications: 0,

    // 我的选品库数据
    preCartCount: 0,
    selectedPreCart: [],
    preCartData: [],

    // 分销者
    distributor: {
        distributorId: 0,
        distributorPid: '',
    },
};

const LeagueStore: Module<ILeagueState, RootState> = {
    namespaced: true,
    state: initialState,
    mutations: {
        setGoodsData(
            state: ILeagueState,
            data: { ruleVos: IGoods[]; totalCount: number; exclusiveNotifications: number }
        ) {
            const { ruleVos, totalCount, exclusiveNotifications } = data;
            state.goodsData = ruleVos;
            state.totalCount = totalCount;
            state.exclusiveNotifications = exclusiveNotifications;
        },
        // 整体设置已选商品
        setSelectedGoods(state: ILeagueState, data: IGoods[] = []) {
            state.selectedGoods = data;
        },
        // 增加已选商品
        addSelectedGoods(state: ILeagueState, data: IGoods[] = []) {
            const { selectedGoods } = state;
            state.selectedGoods = [...data, ...selectedGoods];
        },
        // 删除已选商品
        removeSelectedGoods(state: ILeagueState, data: IGoods[] = []) {
            const rmItemIds = data.map(item => item.itemId) || [];
            const { selectedGoods } = state;
            rmItemIds.forEach(itemId => {
                const selectedIds = selectedGoods.map(item => item.itemId);
                const idx = selectedIds.indexOf(itemId);
                if (idx > -1) {
                    selectedGoods.splice(idx, 1);
                }
            });
            state.selectedGoods = selectedGoods;
        },
        setGoodsSelectedStatus(state: ILeagueState, data: { itemIds: any[]; status: boolean }) {
            const { goodsData } = state;
            const { status } = data;
            let { itemIds } = data;
            itemIds = itemIds.map(item => item);
            // 更改这些itemId商品的状态
            goodsData.map(goods => {
                const { itemId } = goods;
                if (itemIds.indexOf(itemId) > -1) {
                    goods.selected = status;
                }
            });
            state.goodsData = goodsData;
        },
        clearGoodsSelectedStatus(state: ILeagueState) {
            const { goodsData } = state;
            state.goodsData = goodsData.map(item => ({ ...item, selected: false }));
        },
        // -----------  分割线 ----------  //
        setPreCartData(state: ILeagueState, data: { ruleVos: IPreCart[]; preCartCount: number }) {
            const { ruleVos, preCartCount } = data;
            state.preCartData = ruleVos;
            state.preCartCount = preCartCount;
        },
        addSelectedPreCart(state: ILeagueState, data: IPreCart[]) {
            let { selectedPreCart } = state;
            selectedPreCart = selectedPreCart.concat(data);
            state.selectedPreCart = selectedPreCart;
        },
        removeSelectedPreCart(state: ILeagueState, data: IPreCart[]) {
            const removeKeys = data.map(item => item.itemId);
            const { selectedPreCart } = state;
            removeKeys.forEach(itemId => {
                const selectedIds = selectedPreCart.map(item => item.itemId);
                const idx = selectedIds.indexOf(itemId);
                if (idx > -1) {
                    selectedPreCart.splice(idx, 1);
                }
            });
            state.selectedPreCart = selectedPreCart;
        },
        resetSelectedPreCart(state: ILeagueState) {
            state.selectedPreCart = [];
        },
        changePreCartItemStatus(state: ILeagueState, data: { itemIds: number[]; selected: boolean }) {
            const { itemIds, selected } = data;
            const { preCartData } = state;
            const newData = preCartData.map(item => {
                const idx = itemIds.indexOf(item.itemId);
                if (idx > -1) {
                    item.selected = selected;
                }
                return item;
            });
            state.preCartData = newData;
        },
        setDistributor(state: ILeagueState, data: IDistributor) {
            state.distributor = data;
        },
    },
    actions: {
        async getLeagueGoodsList(
            { commit, dispatch, state, rootState },
            payload: { searchPoolParam: ISearchPoolParam }
        ) {
            // 【todo】联调时候换v2版本的接口和接口字段
            const { data: {ruleVos, page , exclusiveNotifications}}: {data: IPoolListVO} = await searchPoolsV2UsingPOST(payload || {}) || {};
            let DB = localStorage.getItem('goods_db') && JSON.parse(localStorage.getItem('goods_db')) || [];
            DB = DB.map(item => ({ ...item, itemId: (item.itemId) }));
            const DBKEYS = DB.map(item => (item.itemId));
            (ruleVos || []).map((item) => {
                if (DBKEYS.indexOf((item.itemId)) > -1) {
                    // @ts-ignore
                    item.selected = true;
                } else {
                    // @ts-ignore
                    item.selected = false;
                }
                return item;
            });
            // 同步DB到vuex,展示到购物车中需要
            commit('setSelectedGoods', DB);
            commit('setGoodsData', { ruleVos, totalCount: (page && page.totalCount) || 0, exclusiveNotifications });
        },
        async getPreCartData({ commit, dispatch, state, rootState }, payload: { searchRuleParam: ISearchRuleParam }) {
            const {
                data: { ruleVos, page },
            }: { data: IRuleListVo } = (await searchRulesUsingPOST(payload || {})) || {};
            const selectedIds = state.selectedPreCart.map(item => item.itemId);
            const res = (ruleVos || []).map(item => {
                let selected = false;
                if (selectedIds.indexOf(item.itemId) > -1) {
                    selected = true;
                }
                return Object.assign(item, { selected });
            });
            commit('setPreCartData', { ruleVos: res, preCartCount: (page && page.totalCount) || 0 });
        },
        async getDistributorData({ commit, dispatch, state, rootState }) {
            const { data } = (await detailUsingPOST()) || {};
            commit('setDistributor', data);
        },
    },
    getters: {},
};

export default LeagueStore;
